import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MomLayout from './MomLayout';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useMomAuth } from '../../context/MomAuthContext';
import { toast } from 'sonner';
import { Heart, Mail, Lock, ArrowRight, Loader2 } from 'lucide-react';

export default function MomLoginPage() {
  const { login } = useMomAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email.trim().toLowerCase(), password);
      navigate(user?.onboarding_completed ? '/mom/dashboard' : '/mom/onboarding', { replace: true });
    } catch (err) {
      let msg = String(err?.message || 'Giriş başarısız');
      if (msg.toLowerCase().indexOf('cloned') !== -1 || err?.name === 'DataCloneError') {
        msg = 'Giriş başarısız. Lütfen tekrar deneyin.';
      }
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <MomLayout>
      <div className="absolute top-0 left-0 right-0 h-56 overflow-hidden -z-10 pointer-events-none">
        <div className="absolute -top-20 -left-10 w-72 h-72 bg-[#FFD6D0] rounded-full opacity-70 blur-2xl"></div>
      </div>

      <div className="flex items-center gap-2 mb-10">
        <div className="w-10 h-10 rounded-2xl bg-[#FB7185] flex items-center justify-center text-white">
          <Heart className="w-5 h-5" fill="currentColor" />
        </div>
        <span className="font-semibold text-[#2D2422] text-lg">BabyFace AI</span>
      </div>

      <h1 className="text-4xl font-bold text-[#2D2422] leading-tight mb-2">
        Tekrar<br/>hoş geldin.
      </h1>
      <p className="text-base text-[#7A6C68] mb-8">Bebeğinin gelişimini takip etmeye devam et.</p>

      <form onSubmit={submit} className="space-y-4" data-testid="mom-login-form">
        <div>
          <Label htmlFor="email" className="text-[#2D2422] text-sm">E-posta</Label>
          <div className="relative mt-1.5">
            <Mail className="w-4 h-4 text-[#7A6C68] absolute left-4 top-1/2 -translate-y-1/2" />
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@mail.com"
              className="pl-11 h-14 rounded-2xl bg-white border-[#F3E5E0] focus:border-[#FB7185] text-base"
              data-testid="mom-login-email" />
          </div>
        </div>
        <div>
          <Label htmlFor="password" className="text-[#2D2422] text-sm">Şifre</Label>
          <div className="relative mt-1.5">
            <Lock className="w-4 h-4 text-[#7A6C68] absolute left-4 top-1/2 -translate-y-1/2" />
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifreniz"
              autoComplete="current-password"
              className="pl-11 h-14 rounded-2xl bg-white border-[#F3E5E0] focus:border-[#FB7185] text-base"
              data-testid="mom-login-password" />
          </div>
        </div>

        <Button type="submit" disabled={busy}
          className="w-full h-14 rounded-2xl bg-[#FB7185] hover:bg-[#F43F5E] text-white text-base font-semibold mt-4"
          data-testid="mom-login-submit-btn">
          {busy ? (<><Loader2 className="w-5 h-5 mr-2 animate-spin" />Giriş yapılıyor...</>) : (<>Giriş Yap<ArrowRight className="w-5 h-5 ml-2" /></>)}
        </Button>
      </form>

      <p className="text-center text-sm text-[#7A6C68] mt-6">
        Henüz hesabın yok mu?{' '}
        <Link to="/mom/register" className="font-semibold text-[#FB7185] hover:text-[#F43F5E]" data-testid="mom-login-register-link">
          Hesap oluştur
        </Link>
      </p>
    </MomLayout>
  );
}
